import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RsncdDlyProg } from '../models/rsncddlyprog.model';
import { Observable } from 'rxjs';

@Injectable()

export class RsncdDlyProgService {
  private rscncddlyprogUrl: string = 'api/rscncddlyprogs';

  constructor(
    private http: HttpClient) { }

  getRsncdDlyProgs(calc_rule_id: number): Observable<RsncdDlyProg[]> {
    let endpointUrl = `${this.rscncddlyprogUrl}/${calc_rule_id}`;
    return this.http.get<RsncdDlyProg[]>(endpointUrl);
  }

  addRsncdDlyProg(calruleDlyProg): Observable<RsncdDlyProg> {
    return this.http.post<RsncdDlyProg>(this.rscncddlyprogUrl, calruleDlyProg);
  }

  updateRsncdDlyProg(calruleDlyProg): Observable<RsncdDlyProg> {
    return this.http.put<RsncdDlyProg>(this.rscncddlyprogUrl, calruleDlyProg);
  }

  deleteRsncdDlyProg(calrule_id: number, absenceCode: number) {
    const params = {
      RsncdDlyProg: calrule_id,
      AbsenceCode: absenceCode
    };
    return this.http.delete(this.rscncddlyprogUrl, { params, responseType: 'text' });
  }
  
}
